import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { AlertTriangle } from 'lucide-react';

interface DeleteRiderConfirmationProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  riderName: string;
  riderId: number;
  onConfirm: (riderId: number) => void;
  isLoading?: boolean;
}

const DeleteRiderConfirmation: React.FC<DeleteRiderConfirmationProps> = ({
  open,
  onOpenChange,
  riderName,
  riderId,
  onConfirm,
  isLoading = false,
}) => {
  const handleConfirm = () => {
    onConfirm(riderId);
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-destructive" />
            <AlertDialogTitle>Delete Rider</AlertDialogTitle>
          </div>
          <AlertDialogDescription className="text-left">
            Are you sure you want to delete <span className="font-semibold">{riderName}</span>?
            This action cannot be undone and will permanently remove:
            <ul className="mt-2 ml-4 list-disc space-y-1 text-sm">
              <li>All rider profile information</li>
              <li>Contact and address details</li>
              <li>KYC verification documents</li>
              <li>Payment methods and wallet balance</li>
              <li>Historical ride data and preferences</li>
              <li>Account and login credentials</li>
            </ul>
            <div className="mt-3 p-3 bg-destructive/10 border border-destructive/20 rounded-md">
              <p className="text-sm text-destructive font-medium">
                <strong>Warning:</strong> This action is permanent and cannot be reversed.
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoading}>
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            disabled={isLoading}
            className="bg-destructive hover:bg-destructive/90"
          >
            {isLoading ? 'Deleting...' : 'Delete Rider'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteRiderConfirmation;